import { TRUCK_DATA } from "./MainSection";
import { TruckMember } from "./TruckMember";

export const TrucksSection = () => (
  <section id="chefs" className="Trucks section-bg">
    <div className="container" data-aos="fade-up">
      <div className="section-header">
        <h2>Chefs</h2>
        <p>
          Our <span>Food Trucks</span>
        </p>
      </div>

      <div className="row gy-4">
        {TRUCK_DATA.map((data) => (
          <TruckMember {...data} />
        ))}
      </div>
    </div>
  </section>
);
